import { DataService } from "./data-service";
import { IHealthcheck } from "../entities/healthcheck";

class HealthCheckService extends DataService {
  constructor() {
    super("healthcheck", 0);
  }

  getHealthcheck() {
    return this.api.get<IHealthcheck>();
  }
}

export const healthCheckService = new HealthCheckService();
